import { Fragment } from 'react'

import { DateLimits } from '../../../context'
import { useDate, useDateLimits } from '../../../hooks'
import { FormFieldsDeadline } from '../../Form'

import {
  NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME,
  NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME,
} from './NewsboardPostProfileEditTimeRangeModal.constants'

export function NewsboardPostProfileEditTimeRangeDateFields({ disabled }) {
  const now = useDate()
  const { maxDate } = useDateLimits()

  return (
    <DateLimits value={{ maxDate, minDate: now }}>
      <FormFieldsDeadline
        autoFocusDate
        Container={Fragment}
        deadlineFieldName={NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME}
        disabled={disabled}
        inputDateLabel='Common.DatePickerStartDateKey'
        inputDatePlaceholder='Common.DatePickerAddDateKey'
        inputTimeLabel='Common.DatePickerTimeKey'
        inputTimePlaceholder='Common.DatePickerAddTimeKey'
        withoutDeadlineFieldName={null}
        withoutDeadlineLabel={null}
      />
      <FormFieldsDeadline
        Container={Fragment}
        deadlineFieldName={NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME}
        disabled={disabled}
        inputDateLabel='Common.DatePickerEndDateKey'
        inputDatePlaceholder='Common.DatePickerAddDateKey'
        inputTimeLabel='Common.DatePickerTimeKey'
        inputTimePlaceholder='Common.DatePickerAddTimeKey'
        withoutDeadlineFieldName={null}
        withoutDeadlineLabel={null}
      />
    </DateLimits>
  )
}
